import { ContentModuleTypes, ContentModuleSubTypes, EVENTS } from '@DavisDigital/interfaces';

class AddButtonModalController {
	
	public contentModule : any;
	public images : [];
	public lesson : any;
	public lessonId : string;
	public portfolioPageId : string;
	
	public disableFileName = false;
	
	public file;
	public fileName = '';
	public fileMode = false; 
	public isLoading = false;
	
	public buttonText = '';
	public buttonUrl = '';
	
	public position;
	
	public type:string;
	
	public alignmentOptions = [
		'Left',
		'Center',
		'Right'
	]
	
	public buttonAlignment = this.alignmentOptions[0];

	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input:not([type="hidden"]):not([ng-show="false"]), select, textarea, [tabindex]:not([tabindex="-1"])';
	
	
	// @ngInject
	constructor(
		public $timeout,
		public $element,
		public contentService, 
		public imageService,
		public ModalService,
		public observerService
	){}
	
	public $onInit = () => {

		// Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;
		
		if(this.contentModule != null){
			
			this.fileMode = this.contentModule.contentModuleSubType_systemCode === ContentModuleSubTypes.FILE;
			this.buttonText = this.contentModule.title; 
			this.buttonAlignment = this.contentModule.alignment;
			
			if(this.fileMode){
				this.fileName = this.contentModule.file_fileName;
				this.disableFileName = true; 
			} else {
				this.buttonUrl = this.contentModule.contentUrl; 
			}
			
		} else {
			this.contentModule = this.contentService.newContentModule( ContentModuleTypes.BUTTON, this.position);
			this.setContentModuleSubType(ContentModuleSubTypes.LINK);
		}

		// Set initial focus and trap focus inside the modal
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				modalEl.setAttribute('aria-modal', 'true');

				// Make all body direct children inert except our modal's parent
				const directiveEl = this.$element[0];
				const bodyChildren = document.body.children;
				for (let i = 0; i < bodyChildren.length; i++) {
					const child = bodyChildren[i] as HTMLElement;
					if (child !== directiveEl && !directiveEl.contains(child) && !child.contains(directiveEl) && child.tagName !== 'SCRIPT' && child.tagName !== 'STYLE') {
						child.setAttribute('inert', '');
						child.setAttribute('data-addbutton-inert', 'true');
					}
				}

				// Add native keydown listener for focus trapping
				modalEl.addEventListener('keydown', (e: KeyboardEvent) => {
					if (e.key === 'Escape') {
						e.preventDefault();
						this.close();
						return;
					}
					if (e.key === 'Tab') {
						const allFocusable = modalEl.querySelectorAll(
							'button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
						);
						// Filter to only visible elements
						const focusableEls = Array.from(allFocusable).filter((el: HTMLElement) => {
							return el.offsetParent !== null && !el.closest('[ng-show]')?.classList.contains('ng-hide');
						});
						if (focusableEls.length === 0) return;
						const firstEl = focusableEls[0] as HTMLElement;
						const lastEl = focusableEls[focusableEls.length - 1] as HTMLElement;

						if (e.shiftKey) {
							if (document.activeElement === firstEl || !modalEl.contains(document.activeElement)) {
								e.preventDefault();
								lastEl.focus();
							}
						} else {
							if (document.activeElement === lastEl || !modalEl.contains(document.activeElement)) {
								e.preventDefault();
								firstEl.focus();
							}
						}
					}
				});

				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}
	
	public launchFileUpload = () =>{
		angular.element('input[name="downloadFile"]').click();
	}

	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}
	
	public setContentModuleSubType = ( systemCode : ContentModuleSubTypes ) =>{
		this.contentModule.contentModuleSubType_systemCode = systemCode;
	}
	
	public setFile = (files) =>{
		
		if(files.length === 0) return; 
	
		this.file = files[0];	
		this.disableFileName = false;
		
		this.$timeout(()=>{
			this.fileName = this.file.name;	
		});
	}
	
	public save = () =>{
		
		this.isLoading = true;

		let entityName = this.type;
		
		let notifyId;
		
		if(this.type === 'lesson'){
			notifyId = this.lessonId;
		} else {
			notifyId = this.portfolioPageId;
		}
		
		this.contentModule.title = this.buttonText;
		this.contentModule.alignment = this.buttonAlignment;
		
		//do we need to save the thing first
		if(notifyId == null || notifyId.length === 0){
			
			// Set content data on the module before emitting
			if(this.contentModule.contentModuleSubType_systemCode === 'cmtButtonFile'){
				this.contentModule.fileName = this.fileName;
				// Attach the file to the content module so the editor can upload it after saving
				if(this.file != null){
					this.contentModule._pendingFile = this.file;
				}
			} else {
				this.contentModule.contentUrl = this.buttonUrl;
			}
			
			// Close this modal first, then emit ADD_CONTENT after cleanup completes.
			// This prevents the close() timeout from stripping backdrop/classes
			// off the save-as modal that the editor opens in response to ADD_CONTENT.
			this.close();
			this.$timeout(() => {
				this.observerService.notify(EVENTS.ADD_CONTENT, this.contentModule);
			}, 600);
    		return;
		}
		
		
		if(this.contentModule.contentModuleSubType_systemCode === 'cmtButtonFile'){
			
			this.contentModule.fileName = this.fileName;
			
			if(this.file != null){
				
				return this.contentService.uploadFileToContentModule(this.file, this.contentModule, notifyId, entityName).then(
					(response) =>{
						this.isLoading=false;
						
						if(response.data.data.success){
							let notifyEvent = this.lessonId?.length ? 'SET_LESSON' : 'SET_PORTFOLIO_PAGE';
							this.observerService.notifyById( EVENTS[notifyEvent], notifyId, response.data.data[entityName]);
							return this.close(); 
						}
						return;
					}	
				);
			}
			
		}  else {
			
			this.contentModule.contentUrl = this.buttonUrl;
			
		}
			
		var eventName = EVENTS.UPDATE_CONTENT;
	
		if( !this.contentModule.contentModuleID || 
			 this.contentModule.contentModuleID.length !== 32
		){
			eventName = EVENTS.ADD_CONTENT;
		}
		
		this.observerService.notifyById( eventName, notifyId, this.contentModule);
		
		this.close();
	}
	
	public close = () =>{
		// Remove inert from background elements
		document.querySelectorAll('[data-addbutton-inert]').forEach((el) => {
			el.removeAttribute('inert');
			el.removeAttribute('data-addbutton-inert');
		});

		this.ModalService.closeModals();

		// Force cleanup after Bootstrap modal transition (300ms default)
		this.$timeout(() => {
			document.body.classList.remove('modal-open');
			document.body.classList.remove('angular-modal-service-active');
			document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
		}, 500);

		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.$timeout(() => {
				if (this.previouslyFocusedElement) {
					this.previouslyFocusedElement.focus();
				}
			}, 600);
		}
	}

}

class AddButtonModal {
	public restrict: string = 'E';
	public templateUrl: string;
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		contentModule:'=?',
		lesson:'=?',
		lessonId:'=?',
		portfolioPageId:'=?',
		position:'='
	};

	public controller = AddButtonModalController;
	public controllerAs = 'addButtonModal';

	public static Factory() {
		var directive:any = ( davisFrontendBasePath ) => new this( davisFrontendBasePath );
		directive.$inject = ['davisFrontendBasePath'];
		return directive;
	}

	constructor(
		private davisFrontendBasePath
	) {
		this.templateUrl = davisFrontendBasePath + '/davisdigital/directives/add-button-modal.html';
	}
}

export { AddButtonModal };